import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { appendScriptsCallback, formatDate, formatDateTime } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getEntityDetails, getPreferredDetails } from '../../../../services/ApiServices';

export function TradingAgencyProfileNewPage(): React.ReactElement {
  const [state, setState] = useState<ITradingAgencyProfile>({ Id: '', LoadingInfo: {} });
  const currentSecurity = useSecurity('Trading', 'AgencyProfile');
  const updatedState: ITradingAgencyProfile = { Id: '', LoadingInfo: {} };
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      updatedState.InputCriteria = 0;
      updatedState.NetGrossRatio = 85;
      setState(updatedState);
      appendScriptsCallback(
        [
          'Areas/Trading/Scripts/Resources/en/res.AgencyProfile.en.js',
          'Areas/Trading/Scripts/Resources/en/Types.en.js',
          'Areas/Trading/Scripts/Enums.js',
          'Areas/Trading/Scripts/AgencyProfile/View.js',
        ],
        'initNewTradingAgencyProfile',
        { viewmodel: updatedState, canEdit: true, canCreate: true, canRemove: true },
      );
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="AgencyProfile" className="controls-container default block">
              <h3>
                Create a New <b>Agency Profiles</b>
              </h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="AgencyProfileCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="AgencyProfileLabelBlockedCode">Blocked</label>
                  <input
                    id="AgencyProfileCheckBlockedCode"
                    defaultChecked
                    name="AgencyProfileCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4 combobox  ">
                  <label htmlFor="MasterAgencyId">Master Agency</label>
                  <select
                    className=""
                    id="AgencyProfileMasterAgencyId"
                    name="MasterAgencyId"
                    defaultValue={state.MasterAgencyId}
                    required
                    data-required-msg="Master  Agency is required"
                  >
                    {state.MasterAgencyId && (
                      <option value={state.MasterAgencyId}>{state.MasterAgencyDisplayValue}</option>
                    )}
                  </select>
                </div>
                <div className="col-md-4 combobox  ">
                  <label htmlFor="AgencyId">Agency</label>
                  <select className="" id="AgencyProfileAgencyId" name="AgencyId" defaultValue={state.AgencyId}>
                    {state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="AgencyProfileAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="field textareafield">
                  <label htmlFor="Comments">Comments</label>
                  <div>
                    <textarea
                      className="k-input k-textbox"
                      cols={20}
                      id="AgencyProfileComments"
                      name="Comments"
                      maxLength={2147483647}
                      rows={5}
                      defaultValue={state.Comments}
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="DefaultSpendType" className="required">
                    Default Actual Spend Type
                  </label>
                  <select
                    className=""
                    id="AgencyProfileDefaultSpendType"
                    name="DefaultSpendType"
                    value={state.DefaultSpendType}
                    required
                    data-required-msg="Default Actual Spend Type is required"
                  >
                    <option value="0">Forecast</option>
                    <option value="1">Planned</option>
                    <option value="2">Ordered</option>
                    <option value="3">Billed</option>
                    <option value="4">Manual</option>
                    <option value="5">Other</option>
                  </select>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="InputCriteria" className="required">
                    Input Criteria
                  </label>
                  <select
                    className=""
                    id="AgencyProfileInputCriteria"
                    name="InputCriteria"
                    value={state.InputCriteria}
                    required
                    data-required-msg="Input Criteria is required"
                  >
                    <option value="0">Fixed</option>
                    <option value="1">Flexible</option>
                    <option value="2">Disabled</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="NetGrossRatio">Net/Gross Ratio</label>
                  <input
                    required
                    data-required-msg="Net/Gross Ratio is required"
                    data-val-number="The field Net/Gross Ratio must be a number."
                    id="AgencyProfileNetGrossRatio"
                    name="NetGrossRatio"
                    type="text"
                    defaultValue={state.NetGrossRatio}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="AgencyProfileSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
              </form>
              <section className="button-toolbar" id="ToolbarAgencyProfile">
                <div className="left">
                  <button id="cancelAgencyProfileButton" type="button" className="k-button button" title="Cancel">
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveAgencyProfileButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

interface ITradingAgencyProfile {
  LoadingInfo: {
    CreationDate?: string;
    CreatedBy?: string;
    CreatedByDisplayValue?: string;
    UpdateDate?: string;
    UpdatedBy?: string;
    UpdatedByDisplayValue?: string;
    SourceStatus?: number;
    Source?: number;
  };
  MasterAgencyId?: string;
  MasterAgencyDisplayValue?: string;
  AgencyId?: string;
  AgencyDisplayValue?: string;
  Alias?: string;
  Comments?: string;
  DefaultSpendType?: number;
  InputCriteria?: number;
  NetGrossRatio?: number;
  Code?: string;
  Display?: string;
  EntityStatus?: number;
  SourceReference?: string;
  Id: string;
  InactiveFrom?: Date;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum DataLoadCriteriaEnum {
  'Fixed' = 0,
  'Flexible' = 1,
  'Disabled' = 2,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum DataLoadModeEnum {
  'Ordered' = 0,
  'Billed' = 1,
}

export function TradingAgencyProfileDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingAgencyProfile>({ Id: '', LoadingInfo: {} });
  const currentSecurity = useSecurity('Trading', 'AgencyProfile');
  React.useEffect(() => {
    if (state.Id == '' && currentSecurity.checkAccess()) {
      getEntityDetails('Trading', 'AgencyProfile', id).then((result) => {
        setState(result.Value[0] as ITradingAgencyProfile);
        appendScriptsCallback(
          [
            'Areas/Trading/Scripts/Resources/en/res.AgencyProfile.en.js',
            'Areas/Trading/Scripts/Resources/en/Types.en.js',
            'Areas/Trading/Scripts/Enums.js',
            'Areas/Trading/Scripts/AgencyProfile/View.js',
            'Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js',
            'Areas/Trading/Scripts/Resources/en/res.ClientProfilePeriod.en.js',
            'Areas/Trading/Scripts/AgencyProfilePeriod/View.js',
            'Areas/Trading/Scripts/Resources/en/res.AgencyProfileUserRole.en.js',
            'Areas/Trading/Scripts/AgencyProfileUserRole/View.js',
          ],
          'initDetailTradingAgencyProfile',
          { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id },
        );
      });
    }
  }, []);
  window['reloadTradingAgencyProfileState'] = (data) => {
    setState(data.Value[0] as ITradingAgencyProfile);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="AgencyProfile" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                  <div className="k-content">
                    <h3>
                      Agency Profiles: <span>{state.Display}</span>
                      <span
                        id="AgencyProfileToggle"
                        className="k-icon k-i-media-manager"
                        style={{ cursor: 'pointer' }}
                      ></span>
                    </h3>
                  </div>
                </div>
                <div className="content-line">
                  {state.MasterAgencyId && (
                    <span className="element">
                      <label>
                        Master Agency: <label className="strong">{state.MasterAgencyDisplayValue}</label>
                      </label>
                    </span>
                  )}
                  {state.AgencyId && (
                    <span className="element">
                      <label>
                        Agency: <label className="strong">{state.AgencyDisplayValue}</label>
                      </label>
                    </span>
                  )}
                  <span className="element">
                    <label>
                      Default Actual Spend Type:{' '}
                      <label className="strong">
                        {state.DefaultSpendType != undefined ? DataLoadModeEnum[state.DefaultSpendType] : ''}
                      </label>
                    </label>
                  </span>
                </div>
              </div>
              <form id="form" action="" style={{ display: 'none' }} className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="AgencyProfileCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="AgencyProfileLabelBlockedCode">Blocked</label>
                  <input
                    id="AgencyProfileCheckBlockedCode"
                    defaultChecked
                    name="AgencyProfileCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4 combobox  ">
                  <label htmlFor="MasterAgencyId">Master Agency</label>
                  <select
                    className=""
                    id="AgencyProfileMasterAgencyId"
                    name="MasterAgencyId"
                    defaultValue={state.MasterAgencyId}
                    required
                    data-required-msg="Master  Agency is required"
                  >
                    {state.MasterAgencyId && (
                      <option value={state.MasterAgencyId}>{state.MasterAgencyDisplayValue}</option>
                    )}
                  </select>
                </div>
                <div className="col-md-4 combobox  ">
                  <label htmlFor="AgencyId">Agency</label>
                  <select className="" id="AgencyProfileAgencyId" name="AgencyId" defaultValue={state.AgencyId}>
                    {state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="AgencyProfileAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="field textareafield">
                  <label htmlFor="Comments">Comments</label>
                  <div>
                    <textarea
                      className="k-input k-textbox"
                      cols={20}
                      id="AgencyProfileComments"
                      name="Comments"
                      maxLength={2147483647}
                      rows={5}
                      defaultValue={state.Comments}
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="DefaultSpendType" className="required">
                    Default Actual Spend Type
                  </label>
                  <select
                    className=""
                    id="AgencyProfileDefaultSpendType"
                    name="DefaultSpendType"
                    value={state.DefaultSpendType}
                    required
                    data-required-msg="Default Actual Spend Type is required"
                  >
                    <option value="0">Forecast</option>
                    <option value="1">Planned</option>
                    <option value="2">Ordered</option>
                    <option value="3">Billed</option>
                    <option value="4">Manual</option>
                    <option value="5">Other</option>
                  </select>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="InputCriteria" className="required">
                    Input Criteria
                  </label>
                  <select
                    className=""
                    id="AgencyProfileInputCriteria"
                    name="InputCriteria"
                    value={state.InputCriteria}
                    required
                    data-required-msg="Input Criteria is required"
                  >
                    <option value="0">Fixed</option>
                    <option value="1">Flexible</option>
                    <option value="2">Disabled</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="NetGrossRatio">Net/Gross Ratio</label>
                  <input
                    required
                    data-required-msg="Net/Gross Ratio is required"
                    data-val-number="The field Net/Gross Ratio must be a number."
                    id="AgencyProfileNetGrossRatio"
                    name="NetGrossRatio"
                    type="text"
                    defaultValue={state.NetGrossRatio}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="AgencyProfileSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
                <div className="clear"></div>
                <div className="content-header">Tracking</div>
                <div className="col-md-4">
                  <label htmlFor="LoadingInfo_SourceStatus">Loading Status</label>
                  <select
                    className=""
                    id="AgencyProfileSourceStatus"
                    name="LoadingInfo.SourceStatus"
                    value={state.LoadingInfo.SourceStatus}
                  >
                    <option value="0">Loaded</option>
                    <option value="1">Processed</option>
                    <option value="2">Pending</option>
                    <option value="3">Reloaded</option>
                    <option value="4">Error</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="LoadingInfo_Source">Source</label>
                  <select
                    className=""
                    id="AgencyProfileSource"
                    name="LoadingInfo.Source"
                    value={state.LoadingInfo.Source}
                  >
                    <option value="0">Owned</option>
                    <option value="1">ExternalPlanning</option>
                    <option value="2">ExternalBuying</option>
                    <option value="3">ExternalFinance</option>
                    <option value="4">ExternalHub</option>
                  </select>
                </div>
                <div className="clear"></div>
                <div className="trackinfo">
                  <div className="line">
                    Created on <span className="when">{formatDateTime(state.LoadingInfo.CreationDate)}</span> by{' '}
                    <span className="who">{state.LoadingInfo.CreatedByDisplayValue}</span>{' '}
                  </div>
                  <div className="line">
                    Last Update on <span className="when">{formatDateTime(state.LoadingInfo.UpdateDate)}</span> by{' '}
                    <span className="who">{state.LoadingInfo.UpdatedByDisplayValue}</span>{' '}
                  </div>
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none' }} id="ToolbarAgencyProfile">
                <div className="left">
                  <button id="cancelAgencyProfileButton" type="button" className="k-button button" title="Cancel">
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveAgencyProfileButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
          <div id="AgencyProfileTabstrip">
            <ul>
              <li id="AgencyProfileAgencyProfilePeriod" className="k-state-active">
                <i className="fas fa-calendar"></i>
                <span className="labeltext">Forecast Periods</span>
              </li>
              <li id="AgencyProfileAgencyProfileUserRole">
                <i className="fas fa-calendar"></i>
                <span className="labeltext">User Roles</span>
              </li>
            </ul>
            <div>
              <div id="associationAgencyProfileAgencyProfilePeriod">
                <div className="k-block grid-details">
                  <h2>Forecast Periods</h2>
                  <div id="AgencyProfilePeriodGrid" className="grid-control"></div>
                </div>
              </div>
            </div>
            <div>
              <div id="associationAgencyProfileAgencyProfileUserRole">
                <div className="k-block grid-details">
                  <h2>User Roles</h2>
                  <div id="AgencyProfileUserRoleGrid" className="grid-control"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}
